import { Input, validateInput, ValidationFunction } from "basis";

export const accountTypeOptions = [
  {
    label: "Credit card or store card",
    value: "credit-card",
  },
  {
    label: "Personal loan",
    value: "personal-loan",
  },
  {
    label: "Motor loan",
    value: "motor-loan",
  },
] as const;

export const accountTypeOptionsAu = [
  ...accountTypeOptions,
  {
    label: "Lpay",
    value: "lpay",
  },
] as const;

export const accountTypeOptionsNz = [
  ...accountTypeOptions,
  {
    label: "Genopay",
    value: "genopay",
  },
] as const;

export const allAccountTypeOptions = [
  ...accountTypeOptionsAu,
  ...accountTypeOptionsNz,
] as const;

export const validateMonthlyAmount: ValidationFunction<typeof Input> = (
  val,
  props,
) => {
  const errors = validateInput(val, props);
  if (errors) {
    return errors;
  }
  const number = Number(val);
  if (number < 10) {
    return "Amount must be at least $10";
  }

  return null;
};
